import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(projectId: Id, data: ApiRequests['api.v1.packages.index']) {
    return await api(route('api.v1.packages.index', projectId), 'get', {
      data,
      casts: {
        search: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        subcontractor: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async create(projectId: Id, data: ApiRequests['api.v1.packages.store']) {
    return await api(route('api.v1.packages.store', projectId), 'post', {
      data,
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.packages.update']) {
    return await api(route('api.v1.packages.update', id), 'patch', {
      data,
      casts: {
        contract_reference: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        liquidated_damages_rate: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        liquidated_damages_value: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        performance_security: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async show(id: Id) {
    return await api(route('api.v1.packages.show', id), 'get');
  },

  async delete(id: Id) {
    return await api(route('api.v1.packages.destroy', id), 'delete');
  },

  navbar: {
    async index(projectId: Id) {
      return await api(route('api.v1.packages.navbar.index', projectId), 'get');
    },
  },

  subcontractor: {
    async dashboardIndex(projectId: Id, data: ApiRequests['api.v1.subcontractor.claims.dashboard.index']) {
      return await api(route('api.v1.subcontractor.claims.dashboard.index', projectId), 'get', {
        data,
        casts: {
          month: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        },
      });
    },

    async dashboardShow(projectId: Id, packageId: Id) {
      return await api(route('api.v1.subcontractor.claims.dashboard.show', [projectId, packageId]), 'get');
    },
  },

  variationOrders: {
    async dashboardIndex(projectId: Id) {
      return await api(route('api.v1.subcontract-variation-orders-dashboard.index', projectId), 'get');
    },
  },
};
